import { Link } from 'react-router-dom';
import { brand } from '@/shared/config/brand';
import { useT } from '@/shared/i18n/useT';
import { AccountMenu, type AccountInfo } from './AccountMenu';
import { BcvChip } from './BcvChip';
import { BrandMark } from './BrandMark';
import { ConnectionStatus, type ConnectionState } from './ConnectionStatus';
import { NotificationBell } from './NotificationBell';
import { ThemeMenu } from './ThemeMenu';

export interface TopbarProps {
  /** Tasa BCV vigente (Bs por USD) o null si aún no hay. */
  bcv: number | null;
  unread: number;
  /** null cuando el backend no ofrece cuentas (modo básico): no se muestra la cuenta. */
  account: AccountInfo | null;
  connection: ConnectionState;
}

/** Barra superior fija (56 px): marca (en móvil), tasa BCV, estado de conexión y tema; campana y cuenta solo desde 1024 px. */
export function Topbar({ bcv, unread, account, connection }: TopbarProps) {
  const { t } = useT();
  return (
    <header className="pt-safe sticky top-0 z-30 border-b border-border-soft bg-bg/90 backdrop-blur">
      <div className="mx-auto flex h-[var(--topbar-h)] max-w-[1200px] items-center gap-2 px-4 md:px-6 lg:px-8">
        <Link
          to="/"
          aria-label={t('aria.brandHome')}
          className="flex min-w-0 items-center gap-2 rounded-md lg:hidden"
        >
          <BrandMark size={32} />
          <span className="hidden font-display text-lg font-bold text-fg xs:inline">
            {brand.name}
          </span>
        </Link>
        <div className="ml-auto flex items-center gap-1">
          <BcvChip tasa={bcv} />
          <ConnectionStatus state={connection} />
          {/* En móvil la campana y la cuenta viven en «Más» (BottomNav): la barra queda libre. */}
          <div className="hidden items-center gap-1 lg:flex">
            <NotificationBell unread={unread} />
            {account ? <AccountMenu account={account} /> : null}
          </div>
          <ThemeMenu />
        </div>
      </div>
    </header>
  );
}
